import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { Title, Body, CenteredContainer } from '@nerdwallet/currency';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

import PressLogoTile from './press-logo-tile';

const PressLogoSalad = ({
  tiles,
  backgroundColor,
  verticalPadding,
  topMargin,
  alignItems,
  isAwardLogo,
  wideTile,
  header,
  color,
  copy,
}) => {
  const renderedTiles = _.map(tiles, (tile, nav) => (
    <PressLogoTile
      isAwardLogo={isAwardLogo}
      wideTile={wideTile}
      key={`item-${nav}`}
      {...tile}
    />
  ));

  const pressLogoContainerStyles = {
    backgroundColor: `${backgroundColor}`,
    paddingTop: `${verticalPadding}`,
    paddingBottom: `${verticalPadding}`,
  };

  const PressLogoContainer = (
    <div
      className={classNames([
        'logo-tile__container',
        classes([
          'margin-horizontal-auto',
          'display-flex',
          'justify-content-flex-start',
          'justify-content-center--wide',
          'flex-direction-row',
          'flex-wrap',
          'align-items-flex-start',
        ]),
        {
          'logo-tile__container--wide': wideTile,
          [classes('align-items-flex-end')]: alignItems === 'flex-end',
        },
      ])}
    >
      {renderedTiles}
    </div>
  );

  return (
    <div
      className={classNames([
        'logo__container',
        classes(topMargin ? 'margin-top-5' : 'margin-top-0'),
      ])}
      style={pressLogoContainerStyles}
    >
      <CenteredContainer
        className={classNames([
          'logo__text',
          classes(['margin-horizontal-3', 'width-100--wide']),
        ])}
      >
        {header && (
          <Title color={color} className="pressLogoHeader" size="small">
            {header}
          </Title>
        )}
        {copy && (
          <Body color={color} className="pressLogoCopy">
            {copy}
          </Body>
        )}
      </CenteredContainer>
      {PressLogoContainer}
    </div>
  );
};

PressLogoSalad.displayName = 'PressLogoSalad';

PressLogoSalad.propTypes = {
  backgroundColor: PropTypes.string,
  isAwardLogo: PropTypes.bool,
  verticalPadding: PropTypes.string,
  tiles: PropTypes.arrayOf(PropTypes.shape(PressLogoSalad.propTypes)),
  nav: PropTypes.string,
  wideTile: PropTypes.bool,
  topMargin: PropTypes.bool,
  header: PropTypes.string,
  color: PropTypes.string,
  alignItems: PropTypes.string,
  copy: PropTypes.string,
};

PressLogoSalad.defaultProps = {
  topMargin: true,
  alignItems: 'flex-start',
};

export default PressLogoSalad;
